import { cn } from '@workspace/ui/lib/utils'
import { CircleCheck } from 'lucide-react'
import { copy } from '../../copy/investor-copy'
import type { CardVariant, RelationshipState } from './types'

/**
 * The follow's status in words. A grey pill for active and ended, an amber one for waiting; a met
 * condition is green text with a tick, not a pill. Never colour alone.
 */
export function StatusChip({
  state,
  variant = 'panel',
}: {
  state: RelationshipState
  /** The page sets its pills at weight 500; the panel's are regular. */
  variant?: CardVariant
}) {
  if (state === 'NONE') return null
  if (state === 'CONDITION_MET') {
    return (
      <span className="inline-flex items-center gap-1 text-xs font-medium text-emerald-400">
        <CircleCheck className="size-3.5" />
        {copy('card.following.chip.met')}
      </span>
    )
  }
  const waiting = state === 'WAITING_CHECK' || state === 'WAITING_PLACE'
  return (
    <span
      className={cn(
        'rounded-full px-2.5 py-1 text-xs',
        variant === 'page' && 'font-medium',
        waiting ? 'bg-amber-500/10 text-amber-400' : 'bg-elevated text-muted-foreground'
      )}
    >
      {waiting
        ? copy(
            state === 'WAITING_PLACE'
              ? 'card.following.chip.waitingSlot'
              : 'card.following.chip.waiting'
          )
        : state === 'ACTIVE'
          ? copy('card.following.chip.active')
          : copy('card.following.chip.ended')}
    </span>
  )
}
